angular.module('zc.master.zcliteAgencyInvoices')
  .config(zcliteAgencyInvoiceRoutes);

zcliteAgencyInvoiceRoutes.$inject = ['$stateProvider'];
function zcliteAgencyInvoiceRoutes($stateProvider) {
  $stateProvider
    .state('admin.master.zcliteAgencyInvoices', {
      url: '/zclite_agency_invoices',
      views: {
        'content@': {
          templateUrl: '/templates/master.zclite_agency_invoices/list.html',
          controller: 'MasterZcliteAgencyInvoicesListController',
          controllerAs: '$ctrl',
          resolve: {
            agencies: MasterAgency => MasterAgency.all(),
            invoices: ($q, agencies, ZcsAgencyInvoice) => {
              const promises = _.map(agencies, agency => {
                const allAndCurrentPromises = $q.all({
                  all: ZcsAgencyInvoice.all(agency.name),
                  current: ZcsAgencyInvoice.find(agency.name, moment().format('YYYY-MM'))
                }).then(({all, current}) => {
                  const allInvoices = all.concat(current);
                  return allInvoices;
                });
                return allAndCurrentPromises;
              });
              return $q.all(promises);
            }
          }
        }
      }
    });
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_agency_invoices/routes.js